import React from 'react';
import './style.css';

export const AboutUs = () => {
  return (
    <div className="page-container about-us-container">
      <header className="about-us-header">
        <h2>About SoApp Social</h2>
        <p className="about-us-lead">
          SoApp Social is building modern, user-centric digital ecosystems for communication,
          collaboration, and next-generation social interaction.
        </p>
      </header>

      <div className="about-us-card box-with-shadow">
        <h3>Our Company</h3>
        <p>
          SoApp Social is a French technology company specializing in the development of digital
          communication platforms, social interaction tools, and collaborative online services.
        </p>
        <p>
          Founded in 2025, SoApp Social designs and operates modern software solutions that help
          individuals, groups, and organizations communicate, collaborate, organize events, and
          share experiences through mobile and web technologies.
        </p>
        <p>
          Our mission is to build scalable, user-centric digital ecosystems that combine
          communication, social interaction, artificial intelligence, and next-generation
          collaborative tools.
        </p>
      </div>

      <div className="about-us-card box-with-shadow">
        <h3>What We Do</h3>
        <p>SoApp Social develops and operates:</p>
        <ul className="about-us-list">
          <li>Mobile and web applications</li>
          <li>Social and communication platforms</li>
          <li>Messaging and video communication tools</li>
          <li>Event and group organization systems</li>
          <li>SaaS services and APIs</li>
          <li>AI-powered digital experiences</li>
          <li>Backend infrastructure and developer tools</li>
        </ul>
        <p>
          Our technologies are designed to facilitate secure, seamless, and innovative interactions
          between users, communities, and businesses.
        </p>
      </div>

      <div className="about-us-card box-with-shadow">
        <h3>Privacy &amp; User Protection</h3>
        <p>
          At SoApp Social, we place strong importance on user privacy, transparency, and data
          protection.
        </p>
        <p>
          All services are developed in compliance with applicable regulations, including the
          General Data Protection Regulation (GDPR / RGPD), and follow strict ethical and legal
          standards regarding personal data management and digital services.
        </p>
      </div>

      <div className="about-us-grid">
        <div className="about-us-card box-with-shadow">
          <h3>Company Information</h3>
          <dl className="about-us-dl">
            <div className="about-us-dl-row">
              <dt>Legal Name</dt>
              <dd>SoApp Social</dd>
            </div>
            <div className="about-us-dl-row">
              <dt>Legal Structure</dt>
              <dd>SAS (Société par Actions Simplifiée)</dd>
            </div>
            <div className="about-us-dl-row">
              <dt>SIREN</dt>
              <dd>989 315 544</dd>
            </div>
            <div className="about-us-dl-row">
              <dt>Main Activity</dt>
              <dd>Computer Programming and Digital Platform Development (APE 6201Z)</dd>
            </div>
            <div className="about-us-dl-row">
              <dt>Registered Office</dt>
              <dd>
                27 Grande Rue
                <br />
                78580 Les Alluets-le-Roi
                <br />
                France
              </dd>
            </div>
            <div className="about-us-dl-row">
              <dt>Date of Incorporation</dt>
              <dd>20 July 2025</dd>
            </div>
          </dl>
        </div>

        <div className="about-us-card box-with-shadow">
          <h3>Management</h3>
          <dl className="about-us-dl">
            <div className="about-us-dl-row">
              <dt>President</dt>
              <dd>Josselin de La Rochefoucauld</dd>
            </div>
            <div className="about-us-dl-row">
              <dt>General Director</dt>
              <dd>Augustin Casse</dd>
            </div>
          </dl>
        </div>
      </div>

      <div className="about-us-card box-with-shadow">
        <h3>Contact</h3>
        <p>For support, partnership inquiries, or general questions, please contact us:</p>
        <div className="about-us-contact">
          <div>
            <span className="about-us-contact-label">Email</span>
            <a href="mailto:support@soappgroup.com" className="about-us-link">
              support@soappgroup.com
            </a>
          </div>
          <div>
            <span className="about-us-contact-label">Website</span>
            <a
              href="https://soappgroup.com"
              target="_blank"
              rel="noopener noreferrer"
              className="about-us-link"
            >
              https://soappgroup.com
            </a>
          </div>
        </div>
      </div>

      <div className="about-us-card box-with-shadow">
        <h3>Our Vision</h3>
        <p>
          We believe the future of digital interaction should be more open, collaborative,
          user-controlled, and innovative.
        </p>
        <p>
          SoApp Social is committed to creating technologies that empower users, communities,
          creators, and developers to build meaningful digital experiences together.
        </p>
      </div>
    </div>
  );
};

export default AboutUs;
